import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthSessionService } from '../services/auth-session.service';

export const authGuard: CanActivateFn = () => {

  const router = inject(Router);

  const authService =
    inject(AuthSessionService);

  if (authService.isTokenValid()) {

    return true;
  }

  router.navigate(['/login']);

  return false;
};